import { memo, useContext } from "react";
import { BankingSDKConnectorsRecipientsPivot } from "ui/forms/OpenBanking";
import { BankingSDKConnectorsRecipientsPivotFormContext } from "./BankingSDKConnectorsRecipientsPivotFormContext";

type Props = {
    readonly initialValues: Pick<
        BankingSDKConnectorsRecipientsPivot.BankingSDKConnectorsRecipientsPivotForm['initialValues'],
        | 'bankId'
        | 'recipientId'
    >;
};

const BankingSDKConnectorsRecipientsPivotForm = ({
    initialValues
}: Props) => (
    <BankingSDKConnectorsRecipientsPivot.Form
        {...useContext(BankingSDKConnectorsRecipientsPivotFormContext)}
        initialValues={BankingSDKConnectorsRecipientsPivot.getInitialValues(initialValues, {
            PaymentProducts: []
        })}
    />
);

export default memo(BankingSDKConnectorsRecipientsPivotForm);
